const IDV = {
  DEL_SEF: { value: 1 }, // ??
  ADD_INS: { value: 2 }, // Add Institute
  DEL_INS: { value: 4 }, // Delete Institute
  UPD_FLD: { value: 8 }, // Update Fields
  ADD_DOC: { value: 16 }, // Add Docs
  DEL_DOC: { value: 32 }, //  Delete Docs
  VEW_PRC: { value: 64 }, // View Price 
  SAV_LTR: { value: 128 } // Save For Later
}

function hasPermission(value, permission) {
  return (value & permission.value) > 0
}

export default {
  IDV,
  hasPermission
}